import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import DefaultButton from '../molecules/DefaultButton';
import RowCenterButton from '../molecules/RowCenterButton';
import TransitionButton from '../molecules/TransitionButton';

interface Props {
  reception_cd: string;
  reception_id: number;
  status_code: number;
  moveNextStep: () => void;
  movePrevStep: () => void;
  is_change: boolean;
}

// KWANKGM03120 住宅ローンしっかり審査事前審査（書類提出）画面のフッタボタン
const FooterExaminationApplicantHousingLoanFirmlyUpload: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status_code,
  moveNextStep,
  movePrevStep,
  is_change,
}) => {
  const history = useHistory();

  /**
   * ナビゲーションを次に遷移
   *
   * KWANKGM03130_住宅ローンしっかり審査事前審査申込入力（確認）
   * */
  const handleClickNext = () => {
    moveNextStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/confirm`);
  };

  /**
   * ナビゲーションを前に遷移
   * 画面をKWANKGM03110_住宅ローンしっかり審査事前審査申込入力詳細 に遷移
   */
  const handleClickPrev = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };
  return (
    <>
      <RowCenterButton>
        <DefaultButton label={'書類を提出する'} strong={false} handleClick={handleClickNext} />
      </RowCenterButton>
      <TransitionButton label="戻る" handleClick={handleClickPrev} />
    </>
  );
};

export default memo(FooterExaminationApplicantHousingLoanFirmlyUpload);
